jQuery(document).ready(function(){
    console.log('cartworking')
  if(window.location.href == window.location.origin+'/cart'){
    console.log('cart page')
  }
    let addVariantId='';
    let removeVariantId='';
    let itemsObj = 
      {
        items: [
          {
           id: addVariantId,
           quantity: 1
          }
        ]
      }
    let updateObj =
      {
        updates: {
          
        }
      }
    function cartManipulation(apiPath,dataObj,productHandle,variantId,status){
      jQuery.ajax({
        url:apiPath,
        method:'POST',
        dataType : "text",
        // contentType: "application/json; charset=utf-8",
        data:dataObj,
        success:function(data){
          if(status == 'adding'){
            if(localStorage.upsellProducts){
              let upsellProds = JSON.parse(localStorage.upsellProducts)
              upsellProds[variantId] = 'inCart'
              localStorage.upsellProducts = JSON.stringify(upsellProds)
            }else{
              let upsellProds = {}
              upsellProds[variantId] = 'inCart'
              localStorage.upsellProducts = JSON.stringify(upsellProds)
            }
          }else{
            if(localStorage.upsellProducts){
              let upsellProds = JSON.parse(localStorage.upsellProducts)
              upsellProds[variantId] = 'outCart'
              localStorage.upsellProducts = JSON.stringify(upsellProds)
            }else{
              let upsellProds = {}
              upsellProds[variantId] = 'outCart'
              localStorage.upsellProducts = JSON.stringify(upsellProds)
            }
          }
          console.log(JSON.parse(data))
          jQuery.ajax({
            url:'/cart.js',
            method:'GET',
            dataType : "text",
            success:function(response){
              jQuery('.backDrop').fadeOut(500)
              let resp = JSON.parse(response)
              let cartItems = resp.items
              let cartTotalPrice = resp.total_price
               cartTotalPrice = cartTotalPrice.toString();
              let len = cartTotalPrice.length;
              cartTotalPrice = cartTotalPrice.substring(0, len-2) + "." + cartTotalPrice.substring(len-2);
              jQuery('#cartCustomPrice span').text('$'+cartTotalPrice)
              cartItems.forEach((item,index) => {
                let i = index+1
                jQuery(".cart__row").each(function(k,v){
                  if(jQuery(this).attr('data-product-handle') == item.handle ){
                    console.log(i)
                    jQuery(this).attr('data-line',i)
                    jQuery(this).find('.qty-container .qty-input').attr('id','updates_'+item.key)
                    jQuery(this).find('.qty-container .qty-input').attr('data-id',item.key)
                    jQuery(this).find('.cart__product-remove').attr('href','/cart/change?line='+i+'&quantity=0')
                     console.log(jQuery(this).find('.cart__product-remove').attr('href'))
                  }
                })
              })
              // jQuery.ajax({
              //     url:'/products/'+productHandle+'.json',
              //     method:'GET',
              //     dataType: 'text',
              //     success:function(res){
              //       jQuery('.backDrop').fadeOut(500)
              //       res = JSON.parse(res)
              //       let variantsArray = res.product.variants
              //       variantsArray.forEach(variantObj => {
              //         if(variantObj.id == variantId){
              //           let calulation
              //           let realcalulation
              //           if(status == 'adding'){
              //             let oldPrice = Number(jQuery('#cartCustomPrice span').text().replace('$',''))
              //             let newPrice = Number(variantObj.price) + oldPrice
              //             jQuery('#cartCustomPrice span').text('$'+Math.abs(newPrice).toFixed(2))
              //           }else{
              //             let oldPrice = Number(jQuery('#cartCustomPrice span').text().replace('$',''))
              //             let newPrice = oldPrice - Number(variantObj.price)
              //             jQuery('#cartCustomPrice span').text('$'+Math.abs(newPrice).toFixed(2))
              //           }
                        
              //           // if(variantObj.compare_at_price != ''){
                          
              //           //   if(status == 'adding'){
              //           //     let fullPrice = Number(jQuery('.cart__subtotal .cart__subtotal-discounted.text-muted.text-strike').text().replace('$',''))
              //           //     calulation = fullPrice + Number(variantObj.compare_at_price)
              //           //     jQuery('.cart__subtotal .cart__subtotal-discounted.text-muted.text-strike').text('$'+calulation.toFixed(2))
                            
              //           //   }else{
              //           //     let fullPrice = Number(jQuery('.cart__subtotal .cart__subtotal-discounted.text-muted.text-strike').text().replace('$',''))
              //           //     calulation = fullPrice - Number(variantObj.compare_at_price)
              //           //     jQuery('.cart__subtotal .cart__subtotal-discounted.text-muted.text-strike').text('$'+calulation.toFixed(2))
              //           //   }
              //           // }else{
              //           //   if(status == 'adding'){
              //           //    let fullPrice = Number(jQuery('.cart__subtotal .cart__subtotal-discounted.text-muted.text-strike').text().replace('$',''))
              //           //     calulation = fullPrice + Number(variantObj.price)
              //           //     jQuery('.cart__subtotal .cart__subtotal-discounted.text-muted.text-strike').text('$'+calulation.toFixed(2))
              //           //   }else{
              //           //    let fullPrice = Number(jQuery('.cart__subtotal .cart__subtotal-discounted.text-muted.text-strike').text().replace('$',''))
              //           //     calulation = fullPrice - Number(variantObj.price)
              //           //     jQuery('.cart__subtotal .cart__subtotal-discounted.text-muted.text-strike').text('$'+calulation.toFixed(2))
                            
              //           //   }
              //           // }
              //           // if(status == 'adding'){
              //           //   let realPrice = Number(jQuery('.cart__subtotal .cart__subtotal-discounted.text-sale').text().replace('$',''))
              //           //   realcalulation = realPrice + Number(variantObj.price)
              //           //   jQuery('.cart__subtotal .cart__subtotal-discounted.text-sale').text('$'+realcalulation.toFixed(2))
              //           // }else{
              //           //   let realPrice = Number(jQuery('.cart__subtotal .cart__subtotal-discounted.text-sale').text().replace('$',''))
              //           //   realcalulation = realPrice - Number(variantObj.price)
              //           //   jQuery('.cart__subtotal .cart__subtotal-discounted.text-sale').text('$'+realcalulation.toFixed(2))
              //           // }

              //           // let bigSaving = calulation - realcalulation
              //           // jQuery('.cart_savings-wrapper-text span').text('$'+bigSaving.toFixed(2))
              //         }
              //       })
              //     }
              //   })
            }
          })
          
          
        }
      })
      
    }
    jQuery('body').on('change','#shippingProtectionService,#expressPrintingService',function(){
      jQuery('.backDrop').fadeIn(500)
      console.log('function starts here')
      let $this = jQuery(this)
      if($this.is(':checked')){
        addVariantId = $this.attr('data-variant')
        itemsObj.items[0].id=addVariantId
        console.log(addVariantId)
        console.log(itemsObj)
        cartManipulation('/cart/add.js',itemsObj,$this.attr('data-handle'),addVariantId,'adding')
      }else{
        removeVariantId = $this.attr('data-variant')
        updateObj.updates[removeVariantId] = 0
        cartManipulation('/cart/update.js',updateObj,$this.attr('data-handle'),removeVariantId,'removing')
        delete updateObj.updates[removeVariantId]
      }
      console.log(updateObj)
    })
    jQuery('body').on('click','.fakeDelButton',function(e){
      jQuery('.backDrop').fadeIn(500)
      let $this = jQuery(this)
      e.preventDefault()
      jQuery.ajax({
          url:'/cart.js',
          method:'GET',
          dataType : "text",
          success:function(res){
              console.log(res)
              res = JSON.parse(res)
              console.log(res)
              cartItems = res.items
              let navidiumExists = false
              let expressExists = false
              cartItems.forEach(item => {
                  if(item.handle == 'navidium-shipping-protection'){
                      console.log(item.handle)
                      navidiumExists = true
                  }
                  if(item.handle == 'first-in-line' ){
                      console.log(item.handle)
                      expressExists = true
                  }
              })
              if(navidiumExists && expressExists){
                  console.log('both true')
                  if(cartItems.length <= 3){
                      console.log('total 3')
                       jQuery.ajax({
                           url:'/cart/update.js',
                           method:'POST',
                           dataType: 'text',
                           data:{
                                'updates': {
                                  '43512992661721': 0,
                                  '42339371679961': 0
                                }
                           },
                           success:function(response){
                               console.log(response)
                             $this.parents('.cart__row').attr('data-line','1')
                             $this.parent().find('.realDelButton').attr('href','/cart/change?line=1&quantity=0')
                               $this.parent().find('.realDelButton')[0].click()
                             setTimeout(() => jQuery('.backDrop').fadeOut(500),1000)
                           }
                       })
                  }else{
                      console.log('more than 3')
                      console.log($this)
                      console.log($this.parent())
                      console.log($this.parent().find('.realDelButton')[0])
                      $this.parent().find('.realDelButton')[0].click()
                    setTimeout(() => jQuery('.backDrop').fadeOut(500),1000)
                  }
              }else if(navidiumExists || expressExists){
                let updateData = ''
                if(navidiumExists){
                    updateData = {
                    'updates': {
                      '42339371679961': 0
                    }
                   }
                }else{
                     updateData = {
                      'updates': {
                        '43512992661721': 0
                      }
                   }
                }
                  console.log('one of them is true')
                  if(cartItems.length <= 2){
                      console.log('total 2')
                       jQuery.ajax({
                           url:'/cart/update.js',
                           method:'POST',
                           dataType: 'text',
                           data:updateData,
                           success:function(response){
                             console.log(response)
                             $this.parents('.cart__row').attr('data-line','1')
                             $this.parent().find('.realDelButton').attr('href','/cart/change?line=1&quantity=0')
                             $this.parent().find('.realDelButton')[0].click()
                             setTimeout(() => jQuery('.backDrop').fadeOut(500),1000)
                           }
                       })
                  }else{
                      console.log('more than 2')
                      $this.parent().find('.realDelButton')[0].click()
                    setTimeout(() => jQuery('.backDrop').fadeOut(500),1000)
                  }
              }else{
                  console.log('both false')
                  $this.parent().find('.realDelButton')[0].click()
                setTimeout(() => jQuery('.backDrop').fadeOut(500),1000)
              }

              $(document).ajaxStop(function(){
                setTimeout("window.location = '/cart'",1500);
              });
          }
      })
    });

    $(".qty-container .qty-adjust").click(function(){
        setTimeout(function () {
            location.reload(true);
          }, 1500);
    });

    if ( $('form.cart-form .cart-products .cart__row.cart-item.card').length < 2 ) {
         console.log('Clearing cart');
          $('.fakeDelButton, .realDelButton').click(function(){
              window.location = '/cart/clear'
          });
    }

  })